import { Direction } from '@modules/common/types';
import { DashboardAddContentMenu } from '@modules/dashboard/components/DashboardAddContentMenu';
import { useDashboardStore } from '@modules/dashboard/store/useDashboardStore';
import {
  alpha,
  Button,
  ButtonProps,
  PopoverOrigin,
  Theme,
} from '@mui/material';
import { useState } from 'react';

interface AddDashboardContentButtonProps {
  rowID?: string;
  sx: ButtonProps['sx'];
  className?: string;
  children: React.ReactNode;
  anchorOrigin?: PopoverOrigin;
  transformOrigin?: PopoverOrigin;
  cellInsertDirection: Direction;
}

export function AddDashboardContentButton({
  sx,
  rowID,
  className,
  children,
  anchorOrigin,
  transformOrigin,
  cellInsertDirection,
}: AddDashboardContentButtonProps) {
  const [menuAnchor, setMenuAnchor] = useState<null | HTMLElement>(null);
  const isMenuOpen = Boolean(menuAnchor);
  const isUpdateDashboardInProgress = useDashboardStore(
    ({ visual }) => visual.isUpdateDashboardInProgress,
  );

  const openMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
    setMenuAnchor(event.currentTarget);
  };

  const closeMenu = () => {
    setMenuAnchor(null);
  };

  const backgroundColor = (theme: Theme) => {
    return `${alpha(theme.palette.primary.main, 0.07)}!important`;
  };

  return (
    <>
      <Button
        disabled={isUpdateDashboardInProgress}
        className={className}
        onClick={openMenu}
        sx={{
          opacity: isMenuOpen ? 1 : 0,
          fontSize: 20,
          transition: 'opacity .25s ease 0s',
          '&:hover': {
            opacity: 1,
            backgroundColor,
          },
          ...sx,
          backgroundColor: isMenuOpen ? backgroundColor : undefined,
        }}
      >
        {children}
      </Button>
      <DashboardAddContentMenu
        rowID={rowID}
        cellInsertDirection={cellInsertDirection}
        isOpen={isMenuOpen}
        anchorEl={menuAnchor}
        onClose={closeMenu}
        anchorOrigin={
          anchorOrigin ?? {
            vertical: 'top',
            horizontal: 'right',
          }
        }
        transformOrigin={
          transformOrigin ?? {
            vertical: 'top',
            horizontal: 'left',
          }
        }
        sx={{ ml: 1 }}
        shouldShowNewOptions={true}
      />
    </>
  );
}
